<template>
    <div class="order_detail-container new-cell-group">
        <div class="base-flex-center">
            <commodity-card v-if="!!orderType"
                    :commodity-info="orderDetail"
                    :show-cost="false"/>
        </div>

        <van-cell-group class="detail-commodity-container">
            <van-cell v-if="!orderType" class="order_detail-card_id" :title="orderDetail.card_info.type_text">
                <template>
                    <van-tag size="large" color="#576b95">No.{{orderDetail.card_info.card_no}}</van-tag>
                </template>
            </van-cell>
            <van-cell v-if="orderType" title="油量" :value="orderDetail.detail.oil_liter + 'L'"></van-cell>
            <van-cell v-if="orderType" title="单价" :value="orderDetail.detail.oil_price + '元/L'"></van-cell>
            <van-cell class="detail-total" title="总价" :value="'¥' + orderDetail.total_amount"/>
            <van-cell class="detail-actual_payment" title="实付款">
                <div class="base-theme-text">¥{{orderDetail.paid_amount}}</div>
            </van-cell>
        </van-cell-group>
        <van-cell-group v-if="!!orderDetail.discount_detail.length" title="优惠信息">
            <van-cell v-for="(item, index) in orderDetail.discount_detail"
                      :key="'discount' + index"
                      class="detail-discount"
                      :title="item.name ? item.name : ''">
                <van-tag class="base-theme-tag round" size="medium">{{item.value}}</van-tag>
            </van-cell>
        </van-cell-group>
        <van-cell-group title="订单信息" class="detail-bill-container">
            <van-cell title="订单编号：" class="detail-order_id" :value="orderDetail.order_no"/>
            <van-cell title="下单时间：" :value="orderDetail.created_at"/>
            <van-cell title="订单状态：" :value="orderState(orderDetail.status)"/>
            <van-cell title="支付方式：">
                <div>{{paymentMethod(orderDetail.payment_method)}}</div>
				<div v-if="isCardPayment">
					<van-tag v-for="(item) in orderDetail.card_info" :key="item.id" size="large" color="#576b95" style="margin:5px 0">No.{{item.card_no}}</van-tag>
				</div>
            </van-cell>
<!--            <van-cell
                v-if="orderDetail.type === 'consume' && orderDetail.status === '1'"
                title=" "
                :value="orderDetail.is_evaluation ? '查看评论' : '开始评论'"
                is-link
                :to="{
                    name: orderDetail.is_evaluation ? 'ShowEvaluate' : 'Evaluate',
                    query: {
                        order_no: orderDetail.order_no
                    }
                 }"
            />-->
        </van-cell-group>
        <van-cell-group title="组合支付详情" class="detail-bill-container" v-if="orderDetail.payment_method === 'combination'">
            <van-cell v-for="(paymentDetailItem, paymentDetailIndex) in orderDetail.payment_detail" :key="paymentDetailIndex" :title="(paymentDetailItem.payment_method === 'card' ? '尾号' + paymentDetailItem.card_no.substr(-4, 4) : '') + $store.state.systemEnum.company.user_order.payment_method[paymentDetailItem.payment_method]" class="detail-order_id">
                <span style="color: #e70808;">{{'￥' + paymentDetailItem.payment_amount}}</span>
            </van-cell>
        </van-cell-group>

        <div v-if="orderDetail.type === 'consume' && orderDetail.status === '1'" style="padding: 10px 10px;">
            <van-row>
                <van-col :span="12">
                    <van-button type="default" block class="van-button--round" @click="gotoEvaluate">{{ orderDetail.is_evaluation ? '查看评论' : '去评价' }}</van-button>
                </van-col>
                <van-col :span="12">
                    <van-button type="default" block class="van-button--round" :disabled="isOrderCanInvoice || orderDetail.invoice_status !== '0'" @click="gotoInvoice">发票申请</van-button>
                </van-col>
            </van-row>
        </div>
        <div v-if="orderDetail.type === 'recharge' && orderDetail.status === '1'" style="padding: 10px 10px;">
            <van-button type="default" block class="van-button--round" @click="gotoInvoice">发票申请</van-button>
        </div>

        <van-row v-if="orderDetail.status === '0' && orderDetail.payment_status === '0'" style="margin-top: 20px;">
            <van-col :span="12">
                <van-button type="danger" block @click="cancel">取消订单</van-button>
            </van-col>
            <van-col :span="12">
                <van-button type="primary" block @click="pay">立即支付</van-button>
            </van-col>
        </van-row>
    </div>
</template>

<script>
    import CommodityCard from '../../components/beilin/CommodityCard'
    import api from '../../assets/js/api'
    import mixin from '../mixin'
    import { Dialog } from 'vant';
    import wx from "weixin-js-sdk";
    import common from "../../assets/js/common";

    export default {
        name: 'OrderDetail',
        props: {
            // 0为充值，1为消费
            // !orderType为充值，!!orderType为消费
            orderType: Number
        },
        components: {CommodityCard},
        mixins: [mixin],
        data () {
            return {
                orderNo: '',
                orderDetail: {
                    // 初始化数据
                    payment_method: '',
                    total_amount: 0.00,
                    paid_amount: 0.00,
                    discount_detail: [],
                    detail: {},
                    site_info: {},
                    card_info: {}
                }
            }
        },
        computed: {
            // 判断是否为油卡支付
            isCardPayment () {
                return this.orderDetail.payment_method.length === 4
            },
            // 判断订单是否可开票
            isOrderCanInvoice() {
                if(this.orderDetail.payment_method !== 'combination' && this.orderDetail.payment_method !== 'wechat_jsapi') return false;

                let orderCanInvoiceDay = parseInt(this.orderDetail.order_can_invoice_day);
                if(orderCanInvoiceDay <= 0) return false;

                let currentDate = new Date();
                let orderDate = new Date(this.orderDetail.created_at);
                currentDate.setDate(currentDate.getDate() - orderCanInvoiceDay);
                return orderDate.getTime() < currentDate.getTime();
            },
        },
        mounted () {
            this.orderNo = this.$route.query.orderNo
            this.getOrderDetail()
        },
        methods: {
            // 获取订单的详细信息
            getOrderDetail () {
                let self = this;
                api.request('/order/detail', {
                    order_no: this.orderNo
                }).then(res => {
                    self.orderDetail = res.data
                    // 油种类名称分割
                    if (self.orderDetail.detail.oil_type) {
                        let gunNumNameArr = self.orderDetail.detail.oil_type.name.split(' ')
                        self.orderDetail.oilModel = gunNumNameArr[0]
                        self.orderDetail.oilName = gunNumNameArr[1]
                        // 触发事件向父组件传值
                        self.$emit('pass-data', self.orderDetail)
                    }
                });
            },
            pay(){
                let self = this;
                api.request('/order/pay_again', {
                    order_no: this.orderNo
                }).then(res => {
                    let paymentInfo = JSON.parse(res.data.payment_info);
                    common.wechatPayReady(paymentInfo.appId, () => {
                        wx.chooseWXPay({
                            timestamp: paymentInfo.timeStamp,
                            nonceStr: paymentInfo.nonceStr,
                            package: paymentInfo.package,
                            signType: paymentInfo.signType,
                            paySign: paymentInfo.paySign,
                            success(res) {
                                self.$toast({
                                    message : '充值成功',
                                    onClose(){
                                        self.getOrderDetail();
                                    },
                                });
                            },
                            fail(res){
                                self.$toast(res.errMsg);
                            },
                        });
                    });
                }).catch(res => {
                    self.$toast.fail(res.msg);
                });
            },
            cancel(){
                let self = this;
                Dialog.confirm({
                    title: '提示',
                    message: '是否要取消该订单？',
                }).then(() => {
                    api.request('/order/cancel', {
                        order_no: this.orderNo
                    }).then(res => {
                        self.$toast.success(res.msg);
                        self.getOrderDetail();
                    }).catch(res => {
                        self.$toast.fail(res.msg);
                    });
                }).catch(() => {});
            },
            gotoEvaluate(){
                this.$router.push({
                    name: this.orderDetail.is_evaluation ? 'ShowEvaluate' : 'Evaluate',
                    query: {
                        order_no: this.orderDetail.order_no,
                    }
                });
            },
            gotoInvoice(){
                let orderDetail = this.orderDetail;
                let query = {};
                if(orderDetail.type === 'consume' && orderDetail.status === '1' && (orderDetail.payment_method === 'combination' || orderDetail.payment_method === 'wechat_jsapi')){
                    query['order_no'] = orderDetail.order_no;
                }
                this.$router.push({
                    name: 'Invoice',
                    query: query,
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    *{
        @include themeify{
            .order_detail-container {
                margin-bottom: 20px;

                .order_item-wrap {
                    width: 80%;
                    margin: 15px 0;
                    padding: 15px;
                    border-radius: 0.3rem;
                    background-color: #FFF;
                }

                .detail-commodity-container .van-cell__value,
                .detail-bill-container .van-cell__value {
                    font-size: 16px;
                }

                .detail-actual_payment {
                    font-weight: bold;
                    .van-cell__title {
                        color: #333333;
                    }

                    .van-cell__value {
                        color: #ee0a24;
                    }
                }

                .detail-order_id .van-cell__title,
                .detail-order_id .van-cell__value {
                    flex: auto;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/order/OrderDetail.vue